export default __webpack_public_path__ + "static/video-f535b1419499efbee83ec5722e595c41.mp4";